import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import {
  Box,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { classes } from './utils';
import { getActivityHistory } from '../../../services/userApi';

const ActivityHistoryGeneralDashboard = () => {
  const [ahData, setAhData] = useState(null);
  const [loading, setLoading] = useState(true);

  const userDetail = useSelector((state) => state.user.user);

  const getRowData = async () => {
    try {
      const organizationId = userDetail?.organization_id;

      const payload = {
        sortType: '',
        sortOn: '',
        query: {
          role: ['ADMIN', 'MANAGER', 'MEMBER'],
          organizationId,
        },
        page: 1,
        limit: 25,
      };
      const result = await getActivityHistory(payload);
      if (result?.data?.rows?.length > 0) {
        setAhData(result?.data?.rows);
        setLoading(false);
      } else if (result?.data?.rows?.length === 0) {
        setAhData([]);
        setLoading(false);
      } else {
        setAhData([]);
        setLoading(true);
      }
    } catch (error) {
      return error;
    }
  };

  useEffect(() => {
    if (userDetail?.organization_id) {
      getRowData();
    }
  }, [userDetail]);

  const limitedData = ahData?.slice(0, 10);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="90%"
      >
        <CircularProgress />
      </Box>
    );
  }
  return (
    <TableContainer className={classes.ahTableMainContainer} component={Paper}>
      <Table stickyHeader>
        <TableHead className={classes.ahTableHead}>
          <TableRow>
            <TableCell className={classes.ahTableHeaderCell}>Name</TableCell>
            <TableCell className={classes.ahTableHeaderCell}>
              EventType
            </TableCell>
            <TableCell className={classes.ahTableHeaderCell}>
              Messages
            </TableCell>
            <TableCell className={classes.ahTableHeaderCell}>
              Timestamp
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {limitedData?.map((item) => (
            <TableRow key={item?.id} className={classes.ahTableRowClass}>
              <TableCell className={classes.ahTableRowCell}>
                {item?.firstName && item?.lastName
                  ? `${item?.firstName} ${item?.lastName}`
                  : '-'}
              </TableCell>
              <TableCell className={classes.ahTableRowCell}>
                {item?.eventType}
              </TableCell>
              <TableCell className={classes.ahTableRowCell}>
                {item?.message}
              </TableCell>
              <TableCell className={classes.ahTableRowCell}>
                {moment
                  .utc(item?.timestamp)
                  .local()
                  .format('DD-MM-YYYY HH:mm:ss')}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ActivityHistoryGeneralDashboard;
